import type { TierPlan } from "../pricing";
import { useRouter } from "../router";

const Check = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/** One canonical membership tier, styled as the design's `.plan-card`
 * (Basic = white surface, Premium = crimson `featured`). Fighter (invite-only) shows an application
 * CTA rather than self-checkout, per D9. */
export function PlanCard({ plan }: { plan: TierPlan }) {
  const { navigate } = useRouter();
  return (
    <div className={`plan-card ${plan.highlighted ? "featured" : ""}`} aria-label={`${plan.name} membership`}>
      {plan.highlighted && <div className="plan-badge">Most popular</div>}
      {plan.inviteOnly && <div className="plan-badge">Invite only</div>}

      <div className="plan-name">{plan.name}</div>
      <p className="plan-tagline">{plan.tagline}</p>
      <p className="plan-summary-text">{plan.blurb}</p>

      <div className="plan-price">
        {plan.inviteOnly ? (
          <span className="invite">By invitation</span>
        ) : (
          <>
            <span className="amt">${plan.priceMonthly}</span>
            <span className="per">/mo</span>
          </>
        )}
      </div>

      <ul className="plan-features">
        {plan.benefits.map((b) => (
          <li key={b}>
            <Check />
            {b}
          </li>
        ))}
      </ul>

      {plan.inviteOnly ? (
        <button className="btn btn-primary plan-cta" onClick={() => navigate("/signup")}>
          {plan.cta}
        </button>
      ) : (
        <button
          className={`btn plan-cta ${plan.highlighted ? "btn-primary" : "btn-ghost"}`}
          onClick={() => navigate(`/signup?tier=${plan.tier}`)}
        >
          {plan.cta}
        </button>
      )}
    </div>
  );
}
